import Vue from "vue";
import VueRouter from "vue-router";
import apiData from "../api/apiData";
import store from "@/store";
// import { apiData } from '../api/index'
Vue.use(VueRouter);

const routes = [
  {
    path: "/notFound",
    name: "NotFound",
    component: () => import("@/views/NotFound"),
  },
  // {
  //   path: '/fuwu/login',
  //   name: 'Login',
  //   component: () => import('@/views/Login')
  // },
  {
    path: "/dataCenter",
    name: "DataCenter",
    component: () => import("@/views/DataCenter"),
  },
  {
    path: "/:company/decisionServices",
    name: "DecisionServices",
    component: () => import("@/views/DecisionServices/DecisionServices.vue"),
    children: [
      {
        path: "/:company/decisionServices",
        redirect: "/:company/liveData",
      },
      {
        path: "/:company/liveData",
        name: "LiveData",
        component: () => import("@/views/DecisionServices/LiveData.vue"),
      },
      {
        path: "/:company/statisticalReport",
        name: "StatisticalReport",
        component: () =>
          import("@/views/DecisionServices/StatisticalReport.vue"),
      },
    ],
  },
  {
    path: "/:company",
    name: "Home",
    component: () => import("@/views/Home"),
  },
  {
    path: "/:company/login",
    name: "Login",
    component: () => import("@/views/Login"),
  },
  {
    path: "/:company/config",
    name: "CardConfig",
    component: () => import("@/components/CardConfig"),
  },
  {
    path: "/:company/article/detail",
    name: "ArticleDetail",
    component: () => import("@/views/ArticleDetail.vue"),
  },
];

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

async function fetchUnitInfo(company) {
  try {
    const resultData = await apiData.getUnitInfo(company);
    console.log("resultData", resultData);
    return resultData.data || null;
  } catch (error) {
    console.error(`[路由守卫] 获取企业信息失败: ${company}`, error);
    return null;
  }
}
router.beforeEach(async (to, from, next) => {
  const company = to.params.company;
  const urlToken = to.query.token;
  const storedToken = sessionStorage.getItem("token");

  // ✅ 1. 自动登录：URL带token且本地无token
  if (urlToken && !storedToken) {
    try {
      const unitInfo = await fetchUnitInfo(company);
      if (unitInfo) {
        // 存储 token 和单位信息
        sessionStorage.setItem("token", urlToken);
        localStorage.setItem(
          company,
          JSON.stringify({
            unit: unitInfo,
            token: urlToken,
          }),
        );
        // 更新 Vuex 状态
        store.commit("changeCardTypes", unitInfo);
      } else {
        console.warn(`[自动登录] 企业信息无效: ${company}`);
      }
    } catch (error) {
      console.error(`[自动登录] 初始化失败: ${company}`, error);
    }
  }

  // ✅ 2. 已登录状态判断（以 sessionStorage 或 URL token 为准）
  const isLoggedIn = !!sessionStorage.getItem("token") || !!urlToken;

  if (isLoggedIn) {
    if (to.name === "Login") {
      // 已登录访问登录页 → 跳首页
      return next({ name: "Home", params: { company } });
    }
    return next(); // 放行其他页面
  }

  // ✅ 3. 未登录：放行特定页面
  if (["NotFound", "ArticleDetail"].includes(to.name)) {
    return next();
  }

  if (to.name === "Login" && to.params.unit) {
    return next(); // 登录页且有 unit 参数，放行
  }

  // ✅ 4. 其他页面：需校验企业是否存在
  if (!company) {
    return next("/fuwu/login");
  }

  const unitInfo = await fetchUnitInfo(company);
  if (unitInfo) {
    return next({
      name: "Login",
      params: { company, unit: unitInfo },
    });
  } else {
    return next("/fuwu/login");
  }
});
export default router;
